export default __webpack_public_path__ + "static/media/trash.ace50642.svg";